<template>
  <widget-wrapper
    title="Cambios en cartera"
    widget-id="widget-portfolio-changes"
    widget-name="Cambios de cartera"
    :has-help="true"
    :help-url="url_iframe"
    :help-title="help_tittle"
    :has-alternate-action="true"
    alternate-action-icon="launch"
    alternate-action-url="/app/portfolio"
    theme="dark"
    @close-widget="_closeWidget"
    @show-help="_sendDataToIframe"
  >
    <div v-if="loading" class="widget-loading">
      <div class="spinner"></div>
    </div>
    
    <div v-else class="portfolio-changes-content">
      <!-- Modern Portfolio Selector -->
      <div v-if="portfolio_list.length > 0" class="portfolio-selector">
        <div class="select-container">
          <select v-model="value_selected" @change="_selectPortfolio" class="custom-select">
            <option 
              v-for="portfolio in portfolio_list" 
              :key="portfolio.name"
              :value="portfolio.name"
            >
              {{ portfolio.value }}
            </option>
          </select>
          <span class="select-arrow material-icons">expand_more</span>
        </div>
      </div>
      
      <!-- Alert Categories Interface -->
      <div v-if="raw_alerts.length > 0" class="alerts-interface">
        <!-- Main Todos Tab and Category Selector -->
        <div class="interface-header">
          <button 
            :class="['todos-tab', { 'active': view_mode === 'all' }]"
            @click="view_mode = 'all'"
          >
            <span class="tab-title">Todos</span>
            <span class="tab-count">{{ total_alerts_count }}</span>
          </button>
          
          <div class="category-selector">
            <select v-model="selected_category" @change="_changeCategory" class="category-select">
              <option value="">Por categoría</option>
              <option 
                v-for="category in alert_categories" 
                :key="category.type"
                :value="category.type"
              >
                {{ category.name }} ({{ category.count }})
              </option>
            </select>
            <span class="select-arrow material-icons">expand_more</span>
          </div>
        </div>
        
        <!-- Alerts Content -->
        <div class="alerts-content">
          <!-- All Alerts View -->
          <div v-if="view_mode === 'all'" class="alerts-list">
            <div 
              v-for="(alert, index) in all_alerts_flat" 
              :key="alert.id || index"
              class="alert-item"
            >
              <div class="alert-number">{{ index + 1 }}</div>
              <div class="alert-content">
                <div class="alert-header">
                  <span class="alert-ticker">{{ alert.ticker }}</span>
                  <span class="alert-category">{{ alert.type_name }}</span>
                </div>
                <div class="alert-message" v-html="alert.data.message"></div>
              </div>
              <!-- <div class="alert-actions" v-if="alert.can_it_be_solved_automatically || alert.can_it_report_error">
                <button v-if="alert.can_it_be_solved_automatically" class="action-btn solve-btn" @click="_applySolution(alert)">
                  Resolver
                </button>
                <button v-if="alert.can_it_report_error && !alert.error_reported" class="action-btn report-btn" @click="_reportError(alert)">
                  Reportar
                </button>
              </div> -->
            </div>
          </div>
          
          <!-- Category Specific View -->
          <div v-else-if="current_category_alerts" class="alerts-list">
            <div 
              v-for="(alert, index) in current_category_alerts" 
              :key="alert.id || index"
              class="alert-item"
            >
              <div class="alert-number">{{ index + 1 }}</div>
              <div class="alert-content">
                <div class="alert-ticker">{{ alert.ticker }}</div>
                <div class="alert-message" v-html="alert.data.message"></div>
              </div>
              <!-- <div class="alert-actions" v-if="alert.can_it_be_solved_automatically || alert.can_it_report_error">
                <button v-if="alert.can_it_be_solved_automatically" class="action-btn solve-btn" @click="_applySolution(alert)">
                  Resolver
                </button>
                <button v-if="alert.can_it_report_error && !alert.error_reported" class="action-btn report-btn" @click="_reportError(alert)">
                  Reportar
                </button>
              </div> -->
            </div>
          </div>
        </div>
      </div>
      
      <!-- Empty State -->
      <div v-else-if="!loading" class="empty-state">
        <div class="empty-icon">📊</div>
        <div class="empty-title">No hay alertas disponibles</div>
        <div class="empty-subtitle">Esta cartera no tiene alertas actualmente</div>
      </div>
    </div>
  </widget-wrapper>
</template>

<script>
import { mapGetters } from "vuex";
import PortfolioList from "@/features/widgets/config/portfolio.json";
import APICaller from "@/shared/mixins/APICaller.js";
import GetPortfolios from "@/features/widgets/mixins/getPortfolios.js";
import WidgetWrapper from "@/features/widgets/components/common/WidgetWrapper.vue";

export default {
  mixins: [APICaller, GetPortfolios],
  name: "PortfolioChanges",
  components: {
    WidgetWrapper
  },
  data() {
    return {
      portfolioJson: PortfolioList,
      portfolio_list: [],
      value_selected: "",
      table_header: ["Alarmas"],
      table_body: [],
      widget_name: {
        id: "widget-portfolio-changes",
        name: "Cambios de cartera",
      },
      loading: true,
      url_iframe: "https://player.vimeo.com/video/187302500?title=0&byline=0&portrait=0&autoplay=1",
      help_tittle: "Ayuda sobre cambios en cartera",
      alert_categories: [],
      active_tab: null,
      raw_alerts: [],
      view_mode: 'all',
      selected_category: '',
      current_category_alerts: [],
    };
  },
  created() {
    this._loadData();
  },
  computed: {
    ...mapGetters(["is_mobile_device"]),
    
    total_alerts_count() {
      return this.raw_alerts.length;
    },
    
    all_alerts_flat() {
      // Return raw alerts directly for the "Todos" view
      return this.raw_alerts;
    },
  },
  methods: {
    _loadData() {
      this.loading = true;
      this._getPortfolios();
    },
    
    _sendDataToIframe: function() {
      this.$emit("url_iframe", this.url_iframe);
      this.$emit("help_tittle", this.help_tittle);
      this.$emit("load_iframe");
    },

    _getPortfolioChanges() {
      this.loading = true;
      this.alert_categories = [];
      this.raw_alerts = [];
      
      let success = (response) => {
        if (response.data.list != undefined) {
          this.raw_alerts = response.data.list["#items"];
          this._categorizeAlerts();
        } else if (response.data.message != undefined) {
          // Handle single message case
          this.raw_alerts = [{
            id: 'message',
            ticker: '',
            type: 'general',
            type_name: 'Información general',
            data: { message: response.data.message["#markup"] },
            can_it_be_solved_automatically: false,
            can_it_report_error: false,
            error_reported: false
          }];
          this._categorizeAlerts();
        }
        this.loading = false;
      };

      let failure = () => {
        this.loading = false;
      };

      let url = "/api/v1/portfolio/alerts/" + this.value_selected;

      if (this.value_selected && this.value_selected != "") {
        const successHandler = new APICaller.SuccessHandler(success);
        const failureHandler = new APICaller.FailureHandler(failure, "152", "Error recuperando alertas.");
        const apiCallConfig = { loadingOverlay: false };

        this._getAPICall(url, successHandler, failureHandler, apiCallConfig);
      } else {
        this.loading = false;
      }
    },

    _categorizeAlerts() {
      const categories = {};
      
      // Group alerts by type
      this.raw_alerts.forEach(alert => {
        const type = alert.type || 'general';
        const typeName = alert.type_name || 'General';
        
        if (!categories[type]) {
          categories[type] = {
            type: type,
            name: typeName,
            alerts: [],
            count: 0
          };
        }
        
        categories[type].alerts.push(alert);
        categories[type].count++;
      });
      
      // Convert to array and sort by type name
      this.alert_categories = Object.values(categories).sort((a, b) => 
        a.name.localeCompare(b.name)
      );
      
      // Reset view to "all" when alerts are updated
      this.view_mode = 'all';
      this.selected_category = '';
    },
    
    _getPortfolios() {
      let success = (response) => {
        if (response.data && response.data.length > 0) {
          this.portfolio_list = response.data.map(p => ({
            name: p.idc,
            value: p.name
          }));
          this._defaultPortfolio();
        } else {
          this.loading = false;
        }
      };

      let failure = () => {
        this.loading = false;
      };

      let url = "/api/v1/portfolio/list";
      const successHandler = new APICaller.SuccessHandler(success);
      const failureHandler = new APICaller.FailureHandler(failure, "ERR-PORTFOLIO", "Error recuperando cartera.");
      const apiCallConfig = { loadingOverlay: false };

      this._getAPICall(url, successHandler, failureHandler, apiCallConfig);
    },

    _defaultPortfolio: function() {
      let success = (response) => {
        if (response.data && response.data.idc) {
          // Set the selected portfolio to the default from preferences
          this.value_selected = response.data.idc;
          this._getPortfolioChanges();
        } else if (this.portfolio_list.length > 0) {
          // If no default set, use the first portfolio
          this.value_selected = this.portfolio_list[0].name;
          this._getPortfolioChanges();
        } else {
          this.loading = false;
        }
      };

      let failure = () => {
        if (this.portfolio_list.length > 0) {
          this.value_selected = this.portfolio_list[0].name;
          this._getPortfolioChanges();
        } else {
          this.loading = false;
        }
      };

      let url = "/api/v1/portfolio-invest-preferences";
      const successHandler = new APICaller.SuccessHandler(success);
      const failureHandler = new APICaller.FailureHandler(failure, "153", "Error recuperando preferencias de inversión.");
      const apiCallConfig = { loadingOverlay: false };

      this._getAPICall(url, successHandler, failureHandler, apiCallConfig);
    },

    _selectPortfolio() {
      this._getPortfolioChanges();
    },

    _closeWidget: function() {
      this.$emit("widget_name", this.widget_name);
    },

    _applySolution(alert) {
      if (!alert.can_it_be_solved_automatically) return;
      
      this.loading = true;
      
      let success = () => {
        // Refresh the alerts after applying solution
        this._getPortfolioChanges();
      };

      let failure = () => {
        this.loading = false;
      };

      let url = "/api/v1/portfolio/alerts/apply-solution/" + this.value_selected;
      
      const successHandler = new APICaller.SuccessHandler(success);
      const failureHandler = new APICaller.FailureHandler(failure, "154", "Error aplicando solución a la alerta.");
      const apiCallConfig = { 
        loadingOverlay: false,
        postData: { alert_id: alert.id }
      };

      this._postAPICall(url, successHandler, failureHandler, apiCallConfig);
    },

    _reportError(alert) {
      if (!alert.can_it_report_error || alert.error_reported) return;
      
      // For now, just mark as reported. In a full implementation, 
      // you might want to show a modal for error description
      this.loading = true;
      
      let success = () => {
        // Refresh the alerts after reporting error
        this._getPortfolioChanges();
      };

      let failure = () => {
        this.loading = false;
      };

      let url = "/api/v1/portfolio/alert-state/" + this.value_selected;
      
      const successHandler = new APICaller.SuccessHandler(success);
      const failureHandler = new APICaller.FailureHandler(failure, "155", "Error reportando error de la alerta.");
      const apiCallConfig = { 
        loadingOverlay: false,
        postData: { 
          alert_id: alert.id,
          state: 'error_reported',
          message: 'Error reportado por el usuario',
          ticker: alert.ticker
        }
      };

      this._postAPICall(url, successHandler, failureHandler, apiCallConfig);
    },

    _changeCategory() {
      this.view_mode = 'category';
      this.current_category_alerts = this.alert_categories.find(c => c.type === this.selected_category)?.alerts || [];
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/features/widgets/components/common/WidgetStyles.scss";

.widget-loading {
  @extend .widget-loading-base;
  background-color: var(--color-background, #0F0F1A);
}

.spinner {
  @extend .loading-spinner;
}

.portfolio-changes-content {
  padding: 12px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  height: 100%;
  overflow: hidden;
}

.portfolio-selector {
  flex-shrink: 0;
  
  .select-container {
    position: relative;
    
    .custom-select {
      width: 100%;
      padding: 10px 12px;
      border: 1px solid var(--color-outline, rgba(255, 255, 255, 0.3));
      border-radius: 6px;
      background-color: var(--color-surface, #20202B);
      color: var(--color-text-primary, #FFFFFF);
      font-size: 14px;
      cursor: pointer;
      appearance: none;
      padding-right: 30px;
      transition: all 0.2s ease;
      
      &:focus {
        outline: none;
        border-color: var(--primary, #00aedd);
        box-shadow: 0 0 0 1px var(--primary, #00aedd);
      }
    }
    
    .select-arrow {
      position: absolute;
      right: 10px;
      top: 50%;
      transform: translateY(-50%);
      pointer-events: none;
      color: var(--color-text-secondary, #BFC2CD);
      font-size: 20px;
    }
  }
}

.modern-table-container {
  flex: 1;
  overflow-y: auto;
  margin-bottom: 20px;
}

.modern-table {
  width: 100%;
  border-collapse: collapse;
  
  th {
    text-align: left;
    padding: 10px;
    font-size: 12px;
    font-weight: 600;
    color: var(--color-text-secondary, #BFC2CD);
    border-bottom: 1px solid var(--color-outline, rgba(255, 255, 255, 0.3));
    position: sticky;
    top: 0;
    background-color: var(--color-surface, #20202B);
  }
  
  td {
    padding: 10px;
    font-size: 13px;
    color: var(--color-text-primary, #FFFFFF);
    border-bottom: 1px solid var(--color-outline, rgba(255, 255, 255, 0.1));
    
    // For HTML content
    ::v-deep a {
      color: var(--primary, #00aedd);
      text-decoration: none;
      
      &:hover {
        text-decoration: underline;
      }
    }
  }
  
  tr {
    transition: background-color 0.15s ease;
    
    &:hover {
      background-color: var(--color-active-surface, #193141);
    }
    
    &:last-child td {
      border-bottom: none;
    }
  }
  
  .empty-row td {
    text-align: center;
    color: var(--color-text-secondary, #BFC2CD);
    font-style: italic;
    padding: 20px 10px;
  }
}

.alerts-interface {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
  
  .interface-header {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 16px;
    flex-shrink: 0;

    .todos-tab {
      display: flex;
      align-items: center;
      gap: 6px;
      padding: 6px 12px;
      border: 1px solid var(--color-outline, rgba(255, 255, 255, 0.3));
      border-radius: 4px;
      background-color: var(--color-surface, #20202B);
      color: var(--color-text-primary, #FFFFFF);
      font-size: 11px;
      cursor: pointer;
      transition: all 0.2s ease;
      white-space: nowrap;
      flex-shrink: 0;

      .tab-title {
        font-weight: 500;
      }

      .tab-count {
        background-color: var(--color-outline, rgba(255, 255, 255, 0.3));
        color: var(--color-text-primary, #FFFFFF);
        border-radius: 10px;
        padding: 1px 6px;
        font-size: 10px;
        font-weight: 600;
        min-width: 16px;
        text-align: center;
        flex-shrink: 0;
      }

      &.active {
        background-color: var(--primary, #00aedd);
        border-color: var(--primary, #00aedd);
        color: var(--color-text-on-highlight, #0F0F1A);

        .tab-count {
          background-color: var(--color-text-on-highlight, #0F0F1A);
          color: var(--primary, #00aedd);
        }
      }

      &:hover:not(.active) {
        background-color: var(--color-active-surface, #193141);
        border-color: var(--primary, #00aedd);
      }
    }

    .category-selector {
      position: relative;
      flex: 1;
      
      .category-select {
        width: 100%;
        padding: 6px 24px 6px 12px;
        border: 1px solid var(--color-outline, rgba(255, 255, 255, 0.3));
        border-radius: 4px;
        background-color: var(--color-surface, #20202B);
        color: var(--color-text-primary, #FFFFFF);
        font-size: 11px;
        cursor: pointer;
        appearance: none;
        transition: all 0.2s ease;
        
        &:focus {
          outline: none;
          border-color: var(--primary, #00aedd);
          box-shadow: 0 0 0 1px var(--primary, #00aedd);
        }

        option {
          background-color: var(--color-surface, #20202B);
          color: var(--color-text-primary, #FFFFFF);
        }
      }
      
      .select-arrow {
        position: absolute;
        right: 8px;
        top: 50%;
        transform: translateY(-50%);
        pointer-events: none;
        color: var(--color-text-secondary, #BFC2CD);
        font-size: 16px;
      }
    }
  }

  .alerts-content {
    flex: 1;
    min-height: 0;
    overflow-y: auto;
    overflow-x: hidden;

    .alerts-list {
      display: flex;
      flex-direction: column;
      gap: 12px;
      padding-right: 4px;
    }
  }
}

.alerts-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.alert-item {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 12px;
  background-color: var(--color-surface, #20202B);
  border: 1px solid var(--color-outline, rgba(255, 255, 255, 0.1));
  border-radius: 8px;
  transition: all 0.2s ease;

  &:hover {
    background-color: var(--color-active-surface, #193141);
    border-color: var(--color-outline, rgba(255, 255, 255, 0.3));
  }

  .alert-number {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    background-color: var(--primary, #00aedd);
    color: var(--color-text-on-highlight, #0F0F1A);
    border-radius: 50%;
    font-size: 12px;
    font-weight: 600;
    flex-shrink: 0;
  }

  .alert-content {
    flex: 1;
    min-width: 0;

    .alert-header {
      display: flex;
      align-items: center;
      gap: 8px;
      margin-bottom: 4px;
      flex-wrap: wrap;

      .alert-ticker {
        font-weight: 600;
        font-size: 14px;
        color: var(--primary, #00aedd);
      }

      .alert-category {
        font-size: 11px;
        color: var(--color-text-secondary, #BFC2CD);
        background-color: var(--color-outline, rgba(255, 255, 255, 0.1));
        padding: 2px 6px;
        border-radius: 3px;
        white-space: nowrap;
      }
    }

    .alert-message {
      font-size: 13px;
      line-height: 1.4;
      color: var(--color-text-primary, #FFFFFF);

      ::v-deep a {
        color: var(--primary, #00aedd);
        text-decoration: none;
        
        &:hover {
          text-decoration: underline;
        }
      }

      ::v-deep strong {
        font-weight: 600;
      }

      ::v-deep em {
        font-style: italic;
      }
    }
  }

  .alert-actions {
    display: flex;
    gap: 8px;
    flex-shrink: 0;

    .action-btn {
      padding: 6px 12px;
      border: none;
      border-radius: 4px;
      font-size: 12px;
      font-weight: 500;
      cursor: pointer;
      transition: all 0.2s ease;

      &.solve-btn {
        background-color: #28a745;
        color: white;

        &:hover {
          background-color: #218838;
        }
      }

      &.report-btn {
        background-color: #ffc107;
        color: #000;

        &:hover {
          background-color: #e0a800;
        }
      }
    }
  }
}

.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
  text-align: center;

  .empty-icon {
    font-size: 48px;
    margin-bottom: 16px;
    opacity: 0.6;
  }

  .empty-title {
    font-size: 18px;
    font-weight: 600;
    color: var(--color-text-primary, #FFFFFF);
    margin-bottom: 8px;
  }

  .empty-subtitle {
    font-size: 14px;
    color: var(--color-text-secondary, #BFC2CD);
  }
}
</style>
